import React from "react";
import { array } from "prop-types";

import CustomStoryCard4 from "../../molecules/custom-story-card4";

import "./fourHorizontalStory.m.css";

const FourHorizontalStory = ({ list }) => (
  <div styleName="wrapper">
    {list.slice(0, 4).map((story, index) => (
      <CustomStoryCard4 key={index} story={story} />
    ))}
  </div>
);

FourHorizontalStory.propTypes = {
  list: array.isRequired
};

export default FourHorizontalStory;
